import { render, staticRenderFns } from "./carousel-actions.vue?vue&type=template&id=95be3fc6&scoped=true&"
import script from "./carousel-actions.vue?vue&type=script&lang=js&"
export * from "./carousel-actions.vue?vue&type=script&lang=js&"
import style0 from "./carousel-actions.vue?vue&type=style&index=0&id=95be3fc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95be3fc6",
  null
  
)

export default component.exports